export default {
  PAGE_TITLE : "Ma Carriere",
  BETA_NOTICE: "Module en phase de test",
  BUTTON_TEXT : "Explorer les plans de carrières!",
  INPUT_PLACEHOLDER : "Taper votre message...",
  CHAT_HEADER_TEXT : "Discuter avec Lumi",
  BTN_DELETE: "Supprimer",
  BTN_DELETE_CONFIRM: "Êtes-vous sûr de vouloir supprimer ce message? Cette action est irréversible.",
  BTN_DELETE_CONFIRM_TITLE: "Confirmation de suppression",
  BTN_DELETE_CONFIRM_CANCEL: "Annuler",
  TSTR_SUCCESS: "Message supprimé",
  TSTR_ERROR: "Erreur lors de la suppression du message",
  PLAN_VALIDATED: "Le plan de carrière a été validé avec succès",
  ERROR_VALIDATING_PLAN: "Erreur lors de la validation du plan",
  PLAN_DEACTIVATED: "Le plan de carrière a été désactivé avec succès",
  ERROR_DEACTIVATING_PLAN: "Erreur lors de la désactivation du plan",
  SURVEYS: {
    TITLE: "Sondages",
    NO_SURVEYS: "Aucun sondage pour le moment, nous vous informerons lorsqu'il y en aura de nouveaux.",
  },
  CHAT_MESSAGE:'Vous discutez avec un assistant IA qui peuvent faire des erreurs. Envisagez de vérifier les informations importantes.',
  PLAN_TRACKING_TITLE: "Plan d'action / Suivi",
  ADD_MEETING_TITLE: "Ajouter une réunion",
  LABEL_MEETING_DATE: "Date du réunion",
  VALIDATION_REQUIRED_DATE: "La date est requise",
  LABEL_HOUR: "Heure",
  LABEL_MINUTE: "Minute",
  LABEL_SUBJECT: "Sujet",
  VALIDATION_REQUIRED_SUBJECT: "Le sujet est requis",
  BTN_ADD_MEETING: "Ajouter la réunion",

  ADD_TRAINING_TITLE: "Ajouter une formation",
  LABEL_TRAINING: "Formation",
  PLACEHOLDER_TRAINING: "Rechercher une formation",
  VALIDATION_REQUIRED_TRAINING: "La formation est requise",
  LABEL_START_DATE: "Date de début",
  LABEL_END_DATE: "Date de fin",
  VALIDATION_REQUIRED_START_DATE: "La date est requise",
  VALIDATION_REQUIRED_END_DATE: "La date est requise",
  VALIDATION_DATE_RANGE: "La date de fin doit être postérieure à la date de début",
  BTN_ADD_TRAINING: "Ajouter la formation",

  SECTION_MEETINGS: "Réunions :",
  SECTION_TRAININGS: "Formations :",
  NO_MEETINGS: "Vous n'avez pas des réunion a atteindre",
  NO_TRAININGS: "Vous n'avez pas des formations a suivre",

  FORMATIONS_CERTIFICATIONS:"Formation et certifications obtenues",

  BILAN_COMPETENCES: "Mon bilan des compétences à développer",

  SHARE_WITH_MANAGER: "Partager avec mon manager",

  ADD_PLAN:' Ajouter un plan',

  PAGE_COLLAB_TITLE: "Carrières des collaborateurs",

  // Buttons & Menus
  BTN_CREATE_PLAN: "Créer un plan de carrière",
  BTN_VIEW: "Voir",
  BTN_VIEW_TOOLTIP: "Voir le plan de carrière",
  BTN_SELECT_USER_PLACEHOLDER: "Sélectionner un collaborateur",
  SEARCH_PLACEHOLDER: "Recherche par collaborateur",
  NO_USER_FOUND: "Aucun utilisateur trouvé",
  
  // Table Headers
  TABLE: {
    COLLABORATOR: "COLLABORATEUR",
    CURRENT_POSITION: "POSTE ACTUEL",
    STATUS: "STATUT",
    ACTIONS: "ACTIONS"
  },

  // Status
  STATUS: {
    DRAFT: "Brouillon",
    IN_PROGRESS: "En cours",
    COMPLETED: "Atteint"
  },

  // Misc
  NO_DATA: "Aucune donnée disponible",

  // Loading
  LOADING: {
    SPINNER_LABEL: "Chargement..."
  },

  // Sort Tooltip or Label (optional if used)
  SORT: {
    BY_CURRENT_POSITION: "Trier par poste actuel",
    BY_STATUS: "Trier par statut"
  },

  // Paginator (if customized)
  PAGINATION: {
    NEXT: "Suivant",
    PREV: "Précédent",
    PAGE: "Page",
    OF: "de",
    ITEMS_PER_PAGE: "Éléments par page"
  },
  BTN_DESACTIVATE: "Désactiver le plan",
  PLAN_STATUS_LABEL: "Status du plan",
  OBJECTIVES: {
    TITLE: "Objectifs de ma carrière",
    OBJECTIVES_LABEL: "Objectifs :",
    ASPIRATIONS_LABEL: "Aspirations professionnelles :",
    MISSING_SKILLS_LABEL: "Compétences à développer :"
  },
  PROGRESS:'Jauge d\'avancement globale',
  SKILLS_TO_DEVELOP: "Mon bilan des compétences à développer",
    PROGRESS_MESSAGE: {
      START: "C'est le début de ton aventure ! Chaque étape te rapproche de ton objectif.",
      EARLY: "Beau départ ! Tu poses les bases d'un avenir solide.",
      MID: "Tu avances bien ! Continue, tu es à mi-chemin de ton évolution.",
      LATE: "Plus de la moitié parcourue ! Garde le rythme, le but est à portée.",
      FINAL: "Tu touches au but ! Encore un petit effort pour valider ton plan de carrière."
    },
  CURRENT_SKILLS: "Mes compétences actuelles",
  AQUIRED_SKILLS: "Compétences acquises",
  TO_DEVELOP_SKILLS: "Compétences à développer",
  SKILLS: {
    ACQUIRED: "Compétences acquises",
    TO_DEVELOP: "Compétences à développer",
    TOTAL: "Compétences"
  },
  TRAININGS: {
    MY_PROGRESS: "Mon bilan des formations",
    STATUS: {
      TO_FOLLOW: "À suivre",
      IN_PROGRESS: "En cours",
      ACHIEVED: "Atteint",
      LATE: "En retard"
    }
  },
  COMMENT: {
    TITLE:'Commentaire du manager',
    NO_COMMENTS: 'Aucun commentaire',
    MODIFIED: "Modifié le",
    SAVE: "Sauvegarder",
    CANCEL: "Annuler"
  }
}